import { io, type Socket } from 'socket.io-client';

import { sessionStorage } from './storage';

const WS_URL = import.meta.env.VITE_WS_URL ?? 'http://localhost:3010';

let _socket: Socket | null = null;

export const getSocket = (): Socket => {
  // Socket unique : le recréer pendant la connexion (non encore `connected`) dupliquait les abonnements
  if (_socket) return _socket;
  _socket = io(WS_URL, {
    transports: ['websocket'],
    autoConnect: true,
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10_000,
    // Relu à chaque (re)connexion : le jeton d'accès est renouvelé régulièrement
    auth: (cb) => cb({ token: sessionStorage.get()?.accessToken }),
  });
  _socket.on('connect', () => console.log('[ws] connected', _socket?.id));
  _socket.on('disconnect', () => console.log('[ws] disconnected'));
  return _socket;
};

export const disconnectSocket = (): void => {
  _socket?.disconnect();
  _socket = null;
};
